import { render } from "./LoadingStore.vue?vue&type=template&id=d58bcc0e"
const script = {}

import exportComponent from "D:\\PHPStudio\\xampp_old2\\htdocs\\office_studio\\2026\\agustus\\frontend-olsera-open-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__